import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { FC, ReactNode } from 'react';
import { TooltipContent } from './TooltipContent';

type TooltipContentProps = TooltipPrimitive.TooltipContentProps;
const TooltipPortal = TooltipPrimitive.Portal;
const TooltipTrigger = TooltipPrimitive.Trigger;
const CNTooltip = TooltipPrimitive.Tooltip;
const TooltipProvider = TooltipPrimitive.TooltipProvider;

type Props = {
  children: ReactNode;
  tooltipContent: ReactNode;
  contentClassName?: string;
  enabled?: boolean;
} & Omit<TooltipContentProps, 'className'>;

export const Tooltip: FC<Props> = ({
  children,
  tooltipContent,
  sideOffset = 5,
  side = 'top',
  contentClassName,
  enabled = true,
}) => {
  if (!enabled) {
    return children;
  }
  return (
    <TooltipProvider delayDuration={100}>
      <CNTooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipPortal>
          <TooltipContent sideOffset={sideOffset} side={side} className={contentClassName}>
            {tooltipContent}
          </TooltipContent>
        </TooltipPortal>
      </CNTooltip>
    </TooltipProvider>
  );
};
